export const TP_SITUACAO = Object.freeze({
  FINALIZADO: 1,
  EDICAO: 2,
  CANCELADO: 3
})

export const TP_ETAPA = Object.freeze({
  CONFIGURACAO: 1,
  LOCAL_DE_PROVA: 2,
  OPCAO: 3,
  CLASSIFICACAO: 4,
  SOLICITACAO_ESPECIAL: 5,
  VAGAS_RESERVADAS: 6,
  MENSAGEM: 7,
  ENVIO_DE_EMAIL_E_SMS: 8
})
